import React from 'react';
import {
  RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories,
  RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems,
  RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems,
  RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems_listLinks
} from '../../../../generated/types/RefreshedMobileSiteNavMenuQuery';
import { RefreshedMobileNavMainCategoryItem } from '../RefreshedMobileNavMainCategoryItem';
import { RefreshedMobileSiteNavExpandable } from '../RefreshedMobileSiteNavExpandable';
import { RefreshedMobileSiteNavMenuLinkItem } from '../RefreshedMobileSiteNavMenuLinkItem';

interface Props {
  data:
    | RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories
    | RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems
    | RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems
    | RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems_listLinks;
  onClose: () => void;
}

export const RefreshedMobileSiteNavMenuVerticalCategory: React.FC<Props> = ({ data, onClose }) => {
  if (data.__typename === 'MobileNavMainCategory') {
    return (
      <RefreshedMobileSiteNavExpandable title={data.label} url={data.url || undefined}>
        {data.mainCategoryItems.map((option, index) => (
          <RefreshedMobileSiteNavMenuVerticalCategory key={index} data={option} onClose={onClose} />
        ))}
      </RefreshedMobileSiteNavExpandable>
    );
  }

  if (data.__typename === 'MobileNavMainCategoryItem') {
    if (data.subItems.length === 0) return null;

    return (
      <>
        {data.subItems.map((option, index) => (
          <RefreshedMobileNavMainCategoryItem key={index} data={option} onClose={onClose} />
        ))}
      </>
    );
  }

  if (data.__typename === 'MobileNavListLink') {
    return (
      <RefreshedMobileSiteNavMenuLinkItem
        url={data.url}
        label={data.label}
        isHighlighter={data.isHighlighter}
        onClick={onClose}
      />
    );
  }

  return null;
};
